<template>
  <div id="data-list-list-view" class="data-list-container vs-con-loading__container">
    <vx-card>
      <template slot="no-body">
        <div class="p-2">
          <!--<vs-switch color="success" v-model="active_geofence">-->
          <!--<span slot="on">Geofence On </span>-->
          <!--<span slot="off">Geofence Off </span>-->
          <!--</vs-switch>-->
          <div class="vx-row flex items-center justify-between">
            <vs-col vs-w="3">
              <VueCtkDateTimePicker no-button-now label="Select Date" format="YYYY-MM-DD"
                :min-date="minStart" :max-date="maxStart" v-model="dateStart" only-date />
            </vs-col>
            <vs-col vs-w="5">
              <vs-button type="gradient" class="shadow btn-load-1 vs-con-loading__container mr-1" color="#d23030"
                v-if="dateStart != null" gradient-color-secondary="#f89595" @click="viewRoute()">View Route
              </vs-button>
              <!-- <vs-button v-if="calculated" type="gradient" class="shadow vs-con-loading__container mr-1"
                color="#922e2e" gradient-color-secondary="#ff4e4e" @click="reroute()">Reroute
              </vs-button>
              <vs-button v-if="calculated" type="gradient" class="shadow vs-con-loading__container" color="#922e2e"
                gradient-color-secondary="#ff4e4e" @click="clear()">Clear
              </vs-button> -->

              <!--<vs-button type="gradient" class="shadow" color="#d23030" v-if="dateEnd!=null"-->
              <!--gradient-color-secondary="#f89595" @click="drawPoint()">View Points-->
              <!--</vs-button>-->
            </vs-col>
            <vs-col vs-w="1" class="flex justify-end items-center">
              <p class="mx-2">Summary</p>
              <vs-switch v-model="summaryData" color="red" />
              <vs-button type="" class="btn-download-1 vs-con-loading__container ml-3 p-0 "
                color="#922e2e" gradient-color-secondary="#ff4e4e" @click="download_data()"><svg width="42" height="42"
                  viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.5" y="0.5" width="41" height="41" rx="7.5" fill="white" />
                  <rect x="0.5" y="0.5" width="41" height="41" rx="7.5" stroke="#EE6D6D" />
                  <path
                    d="M21 24.575C20.8667 24.575 20.7417 24.5543 20.625 24.513C20.5083 24.4717 20.4 24.4007 20.3 24.3L16.7 20.7C16.5 20.5 16.404 20.2667 16.412 20C16.42 19.7333 16.516 19.5 16.7 19.3C16.9 19.1 17.1377 18.996 17.413 18.988C17.6883 18.98 17.9257 19.0757 18.125 19.275L20 21.15V14C20 13.7167 20.096 13.4793 20.288 13.288C20.48 13.0967 20.7173 13.0007 21 13C21.2827 12.9993 21.5203 13.0953 21.713 13.288C21.9057 13.4807 22.0013 13.718 22 14V21.15L23.875 19.275C24.075 19.075 24.3127 18.979 24.588 18.987C24.8633 18.995 25.1007 19.0993 25.3 19.3C25.4833 19.5 25.5793 19.7333 25.588 20C25.5967 20.2667 25.5007 20.5 25.3 20.7L21.7 24.3C21.6 24.4 21.4917 24.471 21.375 24.513C21.2583 24.555 21.1333 24.5757 21 24.575ZM15 29C14.45 29 13.9793 28.8043 13.588 28.413C13.1967 28.0217 13.0007 27.5507 13 27V25C13 24.7167 13.096 24.4793 13.288 24.288C13.48 24.0967 13.7173 24.0007 14 24C14.2827 23.9993 14.5203 24.0953 14.713 24.288C14.9057 24.4807 15.0013 24.718 15 25V27H27V25C27 24.7167 27.096 24.4793 27.288 24.288C27.48 24.0967 27.7173 24.0007 28 24C28.2827 23.9993 28.5203 24.0953 28.713 24.288C28.9057 24.4807 29.0013 24.718 29 25V27C29 27.55 28.8043 28.021 28.413 28.413C28.0217 28.805 27.5507 29.0007 27 29H15Z"
                    fill="#EE6D6D" />
                </svg>

              </vs-button>
            </vs-col>
          </div>
        </div>
        <div id="loading-container" class="w-full"></div>

        <vs-divider style="margin: 0" />
        <vs-row vs-w="12">
          <div class="heights" style="position: relative">
            <div v-if="overlay" style="
                z-index: 4;
                position: absolute;
                top: 0;
                width: 100%;
                height: 100%;
                background: rgba(255, 255, 255, 0.87);
              ">
              <p style="
                  color: #000;
                  font-size: 17px;
                  font-weight: bold;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                ">
                Please select date range First
              </p>
            </div>
            <span></span>
            <div class="legenda">
              <div>
                <div class="buletan item"></div>
                <div>Start/End Point</div>
              </div>
              <div>
                <div class="buletan biru"></div>
                <div>Way Point</div>
              </div>
              <div>
                <div class="buletan merah"></div>
                <div>Event Point</div>
              </div>
            </div>
            <div class="control-side">
              <vs-button v-if="
                getRolePermission().vehicle_details.periodic_track.show_graph
              " :color="`${isGraphVisible ? 'danger' : 'white'}`" type="filled" class="p-3"
                @click="isGraphVisible = !isGraphVisible">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M14.9435 21.088V3.91199C14.9435 3.3597 14.4958 2.91199 13.9435 2.91199H9.88528C9.333 2.91199 8.88528 3.3597 8.88528 3.91199V21.088M14.9435 21.088L14.9419 10.7681C14.9418 10.2158 15.3896 9.76799 15.9419 9.76799H20C20.5523 9.76799 21 10.2157 21 10.768V20.088C21 20.6403 20.5523 21.088 20 21.088H14.9435ZM14.9435 21.088H8.88528M8.88528 21.088V16.088C8.88528 15.5357 8.43757 15.088 7.88528 15.088H4C3.44771 15.088 3 15.5357 3 16.088V20.088C3 20.6403 3.44771 21.088 4 21.088H8.88528Z"
                    :stroke="isGraphVisible ? 'white' : '#EE6D6D'" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </vs-button>
            </div>
            <div class="control-place">
              <div class="controls">
                <div class="control-btn" @click="restartPlay()">
                  <feather-icon svgClasses="h-4 w-4" class="cursor-pointer" icon="RefreshCwIcon"></feather-icon>
                </div>
                <div class="control-btn" @click="slower()">
                  <feather-icon svgClasses="h-4 w-4" class="cursor-pointer" icon="RewindIcon"></feather-icon>
                </div>
                <div class="control-btn" v-if="!isResume" @click="resumeAnimation()">
                  <feather-icon svgClasses="h-4 w-4" class="cursor-pointer" icon="PlayIcon"></feather-icon>
                </div>
                <div v-if="isResume" class="control-btn" @click="pauseAnimation()">
                  <feather-icon svgClasses="h-4 w-4" class="cursor-pointer" icon="PauseIcon"></feather-icon>
                </div>
                <div class="control-btn" @click="faster()">
                  <feather-icon svgClasses="h-4 w-4" class="cursor-pointer" icon="FastForwardIcon"></feather-icon>
                </div>
                <div class="bg-white rounded-full py-2 px-3 ml-1">
                  {{ Number(1 / (this.baseSpeed / 8)).toFixed(2) }}x
                </div>
              </div>
              <div class="px-2 py-1 rounded-lg bg-white">
                <range-slider v-if="this.selectedLocation" class="slider w-full control-slider" min="0"
                  :max="sliderMaxValue" step="1" v-model="sliderValue">
                  <template v-slot:knob>
                    <div @mouseenter="isKnobHover = true" @mouseleave="isKnobHover = false">
                      <vs-button class="p-0"></vs-button>
                      <div :class="isKnobHover ? '' : 'hidden'" style="
                          top: -45px;
                          left: -40px;
                          position: absolute;
                          padding: 5px;
                          background-color: #ff1111;
                          color: white;
                          border-radius: 10px;
                          font-size: 12px;
                          width: 100px;
                          text-align: center;
                        ">
                        {{ selectedLocation.device_time }}
                      </div>
                    </div>
                  </template>
                </range-slider>
              </div>
            </div>
            <GmapMap v-if="showMap" ref="mapRef" :center="center" class="playback-map" style="width: 100%; height: 100%"
              :options="{
                zoomControl: true,
                mapTypeControl: true,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: false,
              }">
              <GmapPolygon> </GmapPolygon>
              <gmap-info-window v-if="selectedLocation !== null" :options="{ pixelOffset: { width: 0, height: 0 } }"
                :position="{
                  lat: selectedLocation.latitude,
                  lng: selectedLocation.longitude,
                }" :opened="infoBoxOpen" @closeclick="infoBoxOpen = false">
                <InfoWindow :selectedLocation="selectedLocation" />
              </gmap-info-window>
            </GmapMap>
          </div>
        </vs-row>
      </template>
    </vx-card>

    <div v-if="this.isGraphVisible" id="chart" class="p-2 rounded-lg bg-white w-full">
      <vs-tabs :color="tabColor" :value="tabIndex" class="h-full">
        <vs-tab v-if="getRolePermission().vehicle_details.periodic_track.show_speed" label="Speed" @click="
          () => {
            tabIndex = 0
            tabColor = 'danger'
          }
        ">
          <div class="con-tab-ejemplo" style="min-height: 235px">
            <PlaybackUPlotChart v-if="this.selectedLocation && useUPlotChart" :rows="response" metric="speed"
              :height="chartHeight" :selected-index="sliderValue" @select-index="handleUPlotSelect"
              @chart-error="handleUPlotError" />
            <vue-apex-charts v-else-if="this.selectedLocation" type="area" :height="chartHeight" width="100%"
              :options="chartOptions" :series="series"></vue-apex-charts>
          </div>
        </vs-tab>
        <vs-tab v-if="
          getRolePermission().vehicle_details.periodic_track.show_ignition
        " label="Ignition" @click="
          () => {
            tabIndex = 1
            tabColor = 'success'
          }
        ">
          <div class="con-tab-ejemplo" style="min-height: 235px">
            <PlaybackUPlotChart v-if="this.selectedLocation && useUPlotChart" :rows="response" metric="ignition"
              :height="chartHeight" :selected-index="sliderValue" @select-index="handleUPlotSelect"
              @chart-error="handleUPlotError" />
            <vue-apex-charts v-else-if="this.selectedLocation" type="area" :height="chartHeight" width="100%"
              :options="chartOptions" :series="series"></vue-apex-charts>
          </div>
        </vs-tab>
        <vs-tab v-if="
          getRolePermission().vehicle_details.periodic_track.show_accu_voltage
        " label="Accu Voltage" @click="
          () => {
            tabIndex = 2
            tabColor = 'primary'
          }
        ">
          <div class="con-tab-ejemplo" style="min-height: 235px">
            <PlaybackUPlotChart v-if="this.selectedLocation && useUPlotChart" :rows="response" metric="accu_voltage"
              :height="chartHeight" :selected-index="sliderValue" @select-index="handleUPlotSelect"
              @chart-error="handleUPlotError" />
            <vue-apex-charts v-else-if="this.selectedLocation" type="area" :height="chartHeight" width="100%"
              :options="chartOptions" :series="series"></vue-apex-charts>
          </div>
        </vs-tab>
        <vs-tab v-if="getRolePermission().vehicle_details.periodic_track.show_fuel" label="Fuel" @click="
          () => {
            tabIndex = 3
            tabColor = 'warning'
          }
        ">
          <div class="con-tab-ejemplo" style="min-height: 235px">
            <PlaybackUPlotChart v-if="this.selectedLocation && useUPlotChart" :rows="response" metric="fuel"
              :height="chartHeight" :selected-index="sliderValue" @select-index="handleUPlotSelect"
              @chart-error="handleUPlotError" />
            <vue-apex-charts v-else-if="this.selectedLocation" type="area" :height="chartHeight" width="100%"
              :options="chartOptions" :series="series"></vue-apex-charts>
          </div>
        </vs-tab>
        <vs-tab v-if="getRolePermission().vehicle_details.periodic_track.show_temp" label="Temperature" @click="
          () => {
            tabIndex = 4
            tabColor = 'warning'
          }
        ">
          <div class="con-tab-ejemplo" style="min-height: 235px">
            <ul v-if="tempTab.length != 0" class="flex justify-end" style="gap: 10px">
              <li v-for="t in tempTab">
                <div class="flex flex-row items-center">
                  <label for="" class="mr-2">{{ t.name }}</label>
                  <vs-switch v-model="t.isActive" />
                </div>
              </li>
            </ul>
            <PlaybackUPlotChart v-if="this.selectedLocation && useUPlotChart" :rows="response" metric="temperature"
              :height="chartHeight" :selected-index="sliderValue" :active-temperature-keys="activeTemperatureKeys"
              @select-index="handleUPlotSelect" @chart-error="handleUPlotError" />
            <vue-apex-charts v-else-if="this.selectedLocation" type="area" :height="chartHeight" width="100%"
              :options="chartOptions" :series="series"></vue-apex-charts>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>

    <!--<vs-button class="mr-3 mb-2" @click="submitForm" >Get Data</vs-button>-->
  </div>
</template>

<script>
import firebase from 'firebase/app'

const car =
  'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
import 'firebase/database'
import circle from '../../assets/images/circle.png'
import half_arrow from '../../assets/images/half_arrow.png'
import circle_ijo from '../../assets/images/circle_ijo.png'
import circle_black from '../../assets/images/circle_black.png'
import circle_red from '../../assets/images/circle_red.png'
import periodic_overspeed from '../../assets/images/periodic_overspeed.png'
import periodic_harsh_brk from '../../assets/images/periodic_harsh_brk.png'
import periodic_harsh_acc from '../../assets/images/periodic_harsh_acc.png'
import periodic_mbcn from '../../assets/images/periodic_mbcn.png'
import periodic_crash from '../../assets/images/periodic_crash.png'
import periodic_geo_in from '../../assets/images/periodic_geo_in.png'
import periodic_geo_out from '../../assets/images/periodic_geo_out.png'
import periodic_default from '../../assets/images/periodic_default.png'
import periodic_overstay_on from '../../assets/images/periodic_overstay_on.png'
import periodic_overstay_off from '../../assets/images/periodic_overstay_off.png'

import * as REPO from '../../repository/index'
import { gmapApi } from 'vue2-google-maps'
import * as moment from 'moment'
import XLSX from 'xlsx'
import RangeSlider from 'vue-range-slider'
import VueApexCharts from 'vue-apexcharts'
// import 'vue-range-slider/dist/vue-range-slider.css'

import InfoWindow from '../components/InfoWindow.vue'
import RouteService from '../../route/RouteService'
import PlaybackUPlotChart from './components/PlaybackUPlotChart.vue'

const initialState = () => {
  return {
    isGraphVisible: false,
    series: [],
    chartStatic: {},
    chartOptions: {
      chart: {
        height: 350,
        type: 'area',
        events: {
          click: function (event, chartContext, opts) {
            const { seriesIndex, dataPointIndex } = opts;
            if (dataPointIndex > 0) {
              this.setSliderValue(dataPointIndex)
            }
          }
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        type: 'datetime',
        categories: [],
      },
      tooltip: {
        x: {
          format: 'dd/MM/yy HH:mm',
        },
      },
    },
    summaryData: false,
    dataGroup: [],
    selectedData: {},
    isKnobHover: false,
    sliderValue: 50,
    sliderMaxValue: 100,
    disabledDates: {
      to: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDay() - 14
      ), // Disable all dates up to specific date
      from: new Date(), // Disable all dates after specific date
    },
    minStart: moment().subtract(9, 'months').format('YYYY-MM-DD'),
    maxStart: moment().format('YYYY-MM-DD'),
    center: { lat: -6.1498619, lng: 106.882887 },
    map: '',
    circle: circle,
    markers: [],
    response: [],
    directionsService: '',
    startLocation: {},
    endLocation: {},
    showMap: true,
    infoBoxOpen: false,
    selectedLocation: null,
    calculated: false,
    directionsRenderer: '',
    location_list: [
      { lat: -6.167909, lng: 106.871585 },
      { lat: -6.170949, lng: 106.865867 },
      { lat: -6.17493, lng: 106.849967 },
      { lat: -6.152307, lng: 106.874697 },
      { lat: -6.149366, lng: 106.874697 },
    ],
    dateStart: null,
    overlay: true,
    step: 50,
    tick: 5,
    k: 0,
    kmStep: 0,
    baseSpeed: 8,
    zoomNow: 0,
    isResume: true,
    icon: null,
    lastVertex: 1,
    eol: null,
    marker: null,
    polyline: null,
    poly2: null,
    timerHandle: null,
    id: '',
    tabIndex: 0,
    tabColor: 'danger',
    chartHeight: 255,
    useUPlotChart: true,
    tempTab: [],
    tempTab: [],
  }
}
export default {
  props: {
    license_plate: String,
    vehicle_category: String,
  },
  components: {
    RangeSlider,
    InfoWindow,
    VueApexCharts,
    PlaybackUPlotChart,
  },
  data: () => ({
    ...initialState(),

  }),
  computed: {
    google: gmapApi,
    activeTemperatureKeys() {
      return this.tempTab
        .filter((item) => item.isActive)
        .map((item) => item.key)
    },
  },
  watch: {
    sliderValue(val) {
      // update kmStep based on sum of dataGroup distance from index 0 to val
      if (!this.dataGroup.length > 0) return
      let sum = 0

      for (let i = 0; i < val; i++) {
        sum += this.dataGroup[i].distance
      }
      this.kmStep = sum

      //

      this.selectedLocation = this.response[val]
      this.map.panTo({
        lat: this.response[val].latitude,
        lng: this.response[val].longitude,
      })
      this.map.setZoom(15)

      if (this.marker) {
        this.marker.setPosition({
          lat: this.response[val].latitude,
          lng: this.response[val].longitude,
        })
        if (!this.isResume) {
          this.icon.rotation = this.response[val].direction
        }
        this.marker.setIcon(this.icon)
      }
      const newX = new Date(
        this.toIsoString(new Date(this.response[val].device_time))
      ).getTime()
      this.chartOptions = {
        ...this.chartOptions,
        chart: { ...this.chartStatic },
        annotations: {
          xaxis: [
            {
              x: newX,
              borderColor: '#999',
              yAxisIndex: 0,
              label: {
                show: true,
                text: 'Rally',
                style: {
                  color: '#fff',
                  background: '#775DD0',
                },
              },
            },
          ],
        },
      }
    },
    isGraphVisible(val) {
      //
      const self = this
      if (val === true) {
        setTimeout(() => {
          const knob = document.getElementById('chartResizeKnob')
          const chart = document.getElementById('chart')
          let isMouseDown = false

          let m_pos
          function resize(e) {
            const dy = m_pos - e.y
            m_pos = e.y
            // make max height 500px and min height 100px
            if (parseInt(getComputedStyle(chart, '').height) < 100) {
              chart.style.height = '100px'
            } else if (parseInt(getComputedStyle(chart, '').height) > 500) {
              chart.style.height = '500px'
            } else {
              chart.style.height =
                parseInt(getComputedStyle(chart, '').height) + dy + 'px'
            }
          }
          knob.addEventListener(
            'mousedown',
            function (e) {
              isMouseDown = true
              m_pos = e.y
              document.addEventListener('mousemove', resize, false)
            },
            false
          )
          document.addEventListener(
            'mouseup',
            function () {
              if (isMouseDown) {
                self.chartOptions = {
                  ...self.chartOptions,
                  chart: {
                    ...self.chartOptions.chart,
                    height:
                      parseInt(getComputedStyle(chart, '').height) - 58 + 'px',
                  },
                }
                this.chartHeight = parseInt(getComputedStyle(chart, '').height)
                //
                document.removeEventListener('mousemove', resize, false)
                isMouseDown = false
              }
            },
            false
          )
        }, 5)
      }
    },
    tempTab: {
      handler(val) {
        if (this.tabIndex !== 4) {
          return
        }

        this.series = val.filter((x) => x.isActive)
      },
      deep: true,
    },
    tempTab: {
      handler(val) {
        if (this.tabIndex !== 4) {
          return
        }

        this.series = val.filter((x) => x.isActive)
      },
      deep: true,
    },
    tabIndex(val) {
      // clear tempTab if tab index is not 4
      if (val !== 4) {
        this.tempTab = []
      }

      // clear tempTab if tab index is not 4
      if (val !== 4) {
        this.tempTab = []
      }

      if (val === 0) {
        this.series = [
          {
            name: 'Speed',
            data: this.response.map((x) => {
              return x.speed
            }),
            color: '#FF5E5D',
          },
        ]
      } else if (val === 1) {
        this.series = [
          {
            name: 'Ignition',
            data: this.response.map((x) => {
              return x.ignition
            }),
            color: '#00D68F',
          },
        ]
      } else if (val === 2) {
        this.series = [
          {
            name: 'Accu Voltage',
            data: this.response.map((x) => {
              return x.external_power_voltage
            }),
          },
        ]
      } else if (val === 3) {
        this.series = [
          {
            name: 'Fuel',
            data: this.response.map((x) => {
              return x.fuel_level_1_x
            }),
            color: '#FFA41B',
          },
        ]
      } else if (val === 4) {
        this.tempTab = [
          {
            name: 'Chiller Temp 1',
            key: 'dallas_temperature_1',
            data: this.response.map((x) => {
              return x.dallas_temperature_1
            }),
            color: '#FFA41B',
            isActive: true,
          },
          {
            name: 'Chiller Temp 2',
            key: 'dallas_temperature_2',
            data: this.response.map((x) => {
              return x.dallas_temperature_2
            }),
            color: '#FFA41B',
            isActive: true,
          },
        ]
      } else if (val === 4) {
        this.tempTab = [
          {
            name: 'Chiller Temp 1',
            key: 'dallas_temperature_1',
            data: this.response.map((x) => {
              return x.dallas_temperature_1
            }),
            color: '#FFA41B',
            isActive: true,
          },
          {
            name: 'Chiller Temp 2',
            key: 'dallas_temperature_2',
            data: this.response.map((x) => {
              return x.dallas_temperature_2
            }),
            color: '#FFA41B',
            isActive: true,
          },
        ]
      }
    },
  },
  created() {
    var self = this
  },
  beforeDestroy() {
    // REPO.unsubscribeVehicle(this.$route.params.id);
    //
  },
  methods: {
    checkStatus(key, val) {
      let selected = JSON.parse(JSON.stringify(this.selectedLocation))
      //
      if (key in selected) {
        if (selected[key] == val) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    download_data() {
      var ProgressBar = require('progressbar.js')
      var bar = new ProgressBar.Line('#loading-container', {
        strokeWidth: 1,
        easing: 'easeInOut',
        duration: 1400,
        borderRadius: '10px',
        color: 'rgba(234, 84, 85, 1)',
        trailColor: '#eee',
        trailWidth: 1,
        svgStyle: { width: '100%', height: '100%', borderRadius: '10px' },
        text: {
          style: {
            color: '#999',
            position: 'absolute',
            right: '0',
            top: '30px',
            padding: 0,
            margin: 0,
            transform: null,
          },
          autoStyleContainer: false,
        },
        from: { color: '#FFEA82' },
        to: { color: '#ED6A5A' },
        step: (state, bar) => {
          bar.setText('Collecting Data ' + Math.round(bar.value() * 100) + ' %')
        },
      })

      bar.animate(0.0)
      this.loadingBtnStart('btn-download-1')
      
      // Set start_date dengan jam 00:01:00 dan end_date dengan jam 23:59:59
      const startDate = moment(this.dateStart).format('YYYY-MM-DD') + ' 00:01:00'
      const endDate = moment(this.dateStart).format('YYYY-MM-DD') + ' 23:59:59'

      // const startDate = '2025-11-19' + ' 00:01:00'
      // const endDate = '2025-11-20' + ' 23:59:59'
      
      REPO.getPlayback({
        start_date: startDate,
        end_date: endDate,
        license_plate: this.license_plate,
      }).then(async (res) => {
        const tmp = res.data.data
        const temp = tmp.map((x, index) => {
          bar.animate(1.0)
                    console.log('temp 1:', x.dallas_temperature_1)

          return {
            'License Plate': x.license_plate,
            Alert: x.event_name,
            Ignition: x.ignition == 0 ? 'OFF' : 'ON',
            Speed: x.speed + ' Km/h',
            Direction: x.direction + '°',
            Date: x.device_time,
            'Driver Name': x.driver_name ? x.driver_name : '-',
            'Driver Phone': x.driver_phone ? x.driver_phone : '-',
            'Temp 1': x.dallas_temperature_1 != null ? x.dallas_temperature_1 : '-',
            'Temp 2': x.dallas_temperature_2 != null ? x.dallas_temperature_2 : '-',
            Gmaps: 'Show Google Map',
            Streetview: 'Show Street View',
          }
        })

        const rows = temp
        const worksheet = XLSX.utils.json_to_sheet(rows)
        for (let i = 0; i < rows.length; i++) {
          worksheet[`K${i + 2}`] = {
            v: 'Show Google Map',
            t: 's',
            l: {
              Target: `https://www.google.com/maps/search/?api=1&query=${tmp[i].latitude},${tmp[i].longitude}`,
              Tooltip: 'Show Google Map',
            },
            s: {
              font: {
                color: { rgb: '0563C1' },
                underline: true,
              },
            },
          }
          worksheet[`L${i + 2}`] = {
            v: 'Show Street View',
            t: 's',
            l: {
              Target: `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${tmp[i].latitude},${tmp[i].longitude}`,
              Tooltip: 'Show Street View',
            },
            s: {
              font: {
                color: { rgb: '0563C1' },
                underline: true,
              },
            },
          }
        }
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dates')

        XLSX.writeFile(
          workbook,
          `periodic_track_${this.license_plate}_${moment().format(
            'YYYY-MM-DD_HHmm'
          )}.xlsx`,
          {
            compression: true,
          }
        )

        this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
        this.$vs.loading.close('#isi_table > .con-vs-loading')
        this.loadingBtnStop('btn-download')
        this.load_done = true
        // destroy bar
        bar.destroy()
        this.loadingBtnStop('btn-download-1')
      })

      this.loadingBtnStop('btn-download-1')
    },
    async getAddress(latitude, longitude) {
      const body = {
        lat: latitude,
        lon: longitude,
      }
      let tmp = await REPO.getAddress(body)
      //
      return tmp.data.data
    },
    format_number(val) {
      if (val) {
        let tmp = Math.round(val)
        return tmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      } else {
        return val
      }
    },
    startAnimation() {
      this.eol = this.polyline.Distance()
      this.map.setCenter(this.polyline.getPath().getAt(0))
      this.marker = new google.maps.Marker({
        position: this.polyline.getPath().getAt(0),
        map: this.map,
        icon: this.icon,
      })

      this.poly2 = new google.maps.Polyline({
        path: [this.polyline.getPath().getAt(0)],
        strokeColor: '#0000FF',
        strokeWeight: 10,
      })
      this.animate()
    },
    Timer(callback, delay, isResume = true) {
      var timerId,
        start,
        remaining = delay

      let pause = function () {
        window.clearTimeout(timerId)
        remaining -= Date.now() - start
      }

      let resume = function () {
        start = Date.now()
        window.clearTimeout(timerId)
        timerId = window.setTimeout(callback, remaining)
      }

      if (isResume) resume()
      else pause()
    },
    faster() {
      if (this.tick > 0) {
        this.baseSpeed = this.baseSpeed / 1.5
      }
    },
    slower() {
      this.baseSpeed = this.baseSpeed * 1.5
    },
    pauseAnimation() {
      this.isResume = false
    },
    resumeAnimation() {
      this.isResume = true
      setTimeout(() => {
        this.animate()
      }, 500)
    },
    restartPlay() {
      this.sliderValue = 0
    },
    animate() {
      const self = this
      // this.kmStep = 0
      // let p = this.polyline.GetPointAtDistance(this.kmStep)

      const animateStep = () => {
        const data = self.dataGroup[this.sliderValue]
        //

        if (data) {
          const distance = data.distance
          const duration = data.duration * 5 // Adjust the duration if needed
          this.endLocation.latlng = new google.maps.LatLng(
            data.anchors[1].latitude,
            data.anchors[1].longitude
          )

          const animateSpeed = () => {
            var p = self.polyline.GetPointAtDistance(this.kmStep)
            let tmp = this.response.find((x) => {
              const latlng = new google.maps.LatLng(x.latitude, x.longitude)
              var distance =
                google.maps.geometry.spherical.computeDistanceBetween(p, latlng)

              if (x == data.anchors[1]) {
                // nothing to see here
              }
              return distance < 30 && x == data.anchors[1]
            })

            if (tmp) {
              if (data.speed == 0 && self.isResume) {
                // sleep for amount of duration and then continue
                setTimeout(() => {
                  this.map.panTo(this.endLocation.latlng)
                  this.sliderValue++
                  clearTimeout(this.timerHandle)
                  animateStep()
                }, duration)
              } else {
                this.map.panTo(this.endLocation.latlng)
                this.sliderValue++
                clearTimeout(this.timerHandle)
                animateStep()
              }
            } else {
              if (data.speed == 0 && self.isResume) {
                setTimeout(() => {
                  this.map.panTo(p)
                  this.sliderValue++
                  clearTimeout(this.timerHandle)
                  animateStep()
                }, 500)
              } else {
                this.step = data.speed * 2
                this.tick = (duration / (distance / this.step)) * this.baseSpeed
                const p = this.polyline.GetPointAtDistance(this.kmStep)
                this.map.panTo(p)
                const lastPosn = this.marker.getPosition()
                this.marker.setPosition(p)
                const heading = google.maps.geometry.spherical.computeHeading(
                  lastPosn,
                  p
                )
                this.icon.rotation = heading
                this.marker.setIcon(this.icon)
                this.kmStep += this.step
                this.timerHandle = new this.Timer(
                  () => {
                    animateSpeed(this.kmStep)
                  },
                  this.tick,
                  this.isResume
                )
              }
            }
          }

          animateSpeed()
        } else {
          // Animation completed
        }
      }

      // Start the animation
      animateStep()
    },
    clear(newState, isRerouting) {
      this.showMap = false
      let self = this
      setTimeout(() => {
        this.showMap = true
        this.$nextTick(() => {
          const body = isRerouting
            ? {
              ...initialState(),
              ...newState,
            }
            : initialState()

          Object.assign(this.$data, body)

          this.$refs.mapRef.$mapPromise
            .then((map) => {
              google.maps.event.addListener(map, 'zoom_changed', function () {
                // Determines map type and prevent illegal zoom levels
                //
                var zoom = map.getZoom()
                self.zoomNow = zoom
                //
              })
              this.map = map
              self.directionsService = new google.maps.DirectionsService()
              var rendererOptions = {
                polylineOptions: {
                  strokeColor: '#78a4ff',
                },
                map: map,
              }
              self.directionsDisplay = new google.maps.DirectionsRenderer(
                rendererOptions
              )

              self.icon = {
                path: car,
                scale: 0.7,
                strokeColor: 'white',
                strokeWeight: 0.1,
                fillOpacity: 1,
                fillColor: '#404040',
                offset: '5%',
                // rotation: parseInt(heading[i]),
                anchor: new google.maps.Point(10, 25), // orig 10,50 back of car, 10,0 front of car, 10,25 center of car
              }
              google.maps.LatLng.prototype.distanceFrom = function (newLatLng) {
                var EarthRadiusMeters = 6378137.0 // meters
                var lat1 = this.lat()
                var lon1 = this.lng()
                var lat2 = newLatLng.lat()
                var lon2 = newLatLng.lng()
                var dLat = ((lat2 - lat1) * Math.PI) / 180
                var dLon = ((lon2 - lon1) * Math.PI) / 180
                var a =
                  Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                  Math.cos((lat1 * Math.PI) / 180) *
                  Math.cos((lat2 * Math.PI) / 180) *
                  Math.sin(dLon / 2) *
                  Math.sin(dLon / 2)
                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
                var d = EarthRadiusMeters * c
                return d
              }

              google.maps.LatLng.prototype.latRadians = function () {
                return (this.lat() * Math.PI) / 180
              }

              google.maps.LatLng.prototype.lngRadians = function () {
                return (this.lng() * Math.PI) / 180
              }

              // === A method which returns the length of a path in metres ===
              google.maps.Polygon.prototype.Distance = function () {
                var dist = 0
                for (var i = 1; i < this.getPath().getLength(); i++) {
                  dist += this.getPath()
                    .getAt(i)
                    .distanceFrom(this.getPath().getAt(i - 1))
                }
                return dist
              }

              // === A method which returns a GLatLng of a point a given distance along the path ===
              // === Returns null if the path is shorter than the specified distance ===
              google.maps.Polygon.prototype.GetPointAtDistance = function (
                metres
              ) {
                // some awkward special cases
                if (metres == 0) return this.getPath().getAt(0)
                if (metres < 0) return null
                if (this.getPath().getLength() < 2) return null
                var dist = 0
                var olddist = 0
                for (
                  var i = 1;
                  i < this.getPath().getLength() && dist < metres;
                  i++
                ) {
                  olddist = dist
                  dist += this.getPath()
                    .getAt(i)
                    .distanceFrom(this.getPath().getAt(i - 1))
                }
                if (dist < metres) {
                  return null
                }
                var p1 = this.getPath().getAt(i - 2)
                var p2 = this.getPath().getAt(i - 1)
                var m = (metres - olddist) / (dist - olddist)
                return new google.maps.LatLng(
                  p1.lat() + (p2.lat() - p1.lat()) * m,
                  p1.lng() + (p2.lng() - p1.lng()) * m
                )
              }

              // === A method which returns an array of GLatLngs of points a given interval along the path ===
              google.maps.Polygon.prototype.GetPointsAtDistance = function (
                metres
              ) {
                var next = metres
                var points = []
                // some awkward special cases
                if (metres <= 0) return points
                var dist = 0
                var olddist = 0
                for (var i = 1; i < this.getPath().getLength(); i++) {
                  olddist = dist
                  dist += this.getPath()
                    .getAt(i)
                    .distanceFrom(this.getPath().getAt(i - 1))
                  while (dist > next) {
                    var p1 = this.getPath().getAt(i - 1)
                    var p2 = this.getPath().getAt(i)
                    var m = (next - olddist) / (dist - olddist)
                    points.push(
                      new google.maps.LatLng(
                        p1.lat() + (p2.lat() - p1.lat()) * m,
                        p1.lng() + (p2.lng() - p1.lng()) * m
                      )
                    )
                    next += metres
                  }
                }
                return points
              }

              // === A method which returns the Vertex number at a given distance along the path ===
              // === Returns null if the path is shorter than the specified distance ===
              google.maps.Polygon.prototype.GetIndexAtDistance = function (
                metres
              ) {
                // some awkward special cases
                if (metres == 0) return this.getPath().getAt(0)
                if (metres < 0) return null
                var dist = 0
                var olddist = 0
                for (
                  var i = 1;
                  i < this.getPath().getLength() && dist < metres;
                  i++
                ) {
                  olddist = dist
                  dist += this.getPath()
                    .getAt(i)
                    .distanceFrom(this.getPath().getAt(i - 1))
                }
                if (dist < metres) {
                  return null
                }
                return i
              }
              // === Copy all the above functions to GPolyline ===
              google.maps.Polyline.prototype.Distance =
                google.maps.Polygon.prototype.Distance
              google.maps.Polyline.prototype.GetPointAtDistance =
                google.maps.Polygon.prototype.GetPointAtDistance
              google.maps.Polyline.prototype.GetPointsAtDistance =
                google.maps.Polygon.prototype.GetPointsAtDistance
              google.maps.Polyline.prototype.GetIndexAtDistance =
                google.maps.Polygon.prototype.GetIndexAtDistance
              self.polyline = new google.maps.Polyline({
                path: [],
                strokeColor: '#78a4ff',
                strokeWeight: 3,
              })
              self.poly2 = new google.maps.Polyline({
                path: [],
                strokeColor: '#78a4ff',
                strokeWeight: 3,
              })
              // this.directionsRenderer = new google.maps.DirectionsRenderer;
              // this.directionsRenderer.setMap(map);
            })
            .finally(() => {
              this.viewRoute()
            })
        })
      }, 1000)
      this.calculated = false
    },
    reroute() {
      const newState = {
        dateStart: this.dateStart,
      }
      this.clear(newState, true)
    },
    initSlider(max) {
      this.sliderValue = 0
      this.sliderMaxValue = max
    },
    toIsoString(date) {
      var tzo = -date.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function (num) {
          return (num < 10 ? '0' : '') + num
        }

      return (
        date.getFullYear() +
        '-' +
        pad(date.getMonth() + 1) +
        '-' +
        pad(date.getDate()) +
        'T' +
        pad(date.getHours()) +
        ':' +
        pad(date.getMinutes()) +
        ':' +
        pad(date.getSeconds()) +
        '.000Z'
        // dif +
        // pad(Math.floor(Math.abs(tzo) / 60)) +
        // ':' +
        // pad(Math.abs(tzo) % 60)
      )
    },
    initChart() {
      //
      this.series = [
        {
          name: 'Speed',
          data: this.response.map((x) => {
            return x.speed
          }),
          color: '#FF5E5D',
        },
      ]

      const cat = this.response.map((x) => {
        return this.toIsoString(new Date(x.device_time))
      })

      this.chartOptions = {
        xaxis: {
          type: 'datetime',
          categories: cat,
        },
        annotations: {
          // yaxis: [
          //   {
          //     y: 50,
          //     borderColor: '#999',
          //     label: {
          //       show: true,
          //       text: 'Speed Limit',
          //       style: {
          //         color: '#fff',
          //         background: '#00E396',
          //       },
          //     },
          //   },
          // ],
          xaxis: [],
        },
      }
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    viewRoute() {
      this.loadingBtnStart('btn-load-1')
      this.loadingBtnStart('playback-map')
      var self = this
      this.isResume = true
      if (this.timerHandle) {
        clearTimeout(this.timerHandle)
      }
      if (this.marker) {
        this.marker.setMap(null)
      }

      if (this.markers && this.markers.length > 0) {
        this.markers.forEach((m) => m.setMap(null))
        this.markers = []
      }

      this.polyline.setMap(null)
      this.poly2.setMap(null)
      this.directionsDisplay.setMap(null)
      this.polyline = new google.maps.Polyline({
        path: [],
        strokeColor: '#78a4ff',
        strokeWeight: 3,
      })
      this.poly2 = new google.maps.Polyline({
        path: [],
        strokeColor: '#78a4ff',
        strokeWeight: 3,
      })
      var rendererOptions = {
        polylineOptions: {
          strokeColor: '#78a4ff',
        },
        map: this.map,
      }
      this.directionsDisplay = new google.maps.DirectionsRenderer(
        rendererOptions
      )
      
      // Set start_date dengan jam 00:01:00 dan end_date dengan jam 23:59:59
      const startDate = moment(this.dateStart).format('YYYY-MM-DD') + ' 00:01:00'
      const endDate = moment(this.dateStart).format('YYYY-MM-DD') + ' 23:59:59'

      // const startDate = '2025-11-19' + ' 00:01:00'
      // const endDate = '2025-11-20' + ' 23:59:59'
      
      REPO.getPlayback({
        start_date: startDate,
        end_date: endDate,
        license_plate: this.license_plate,
        summary_track: this.summaryData,
      })
        .then((res) => {
          let waypoints = []
          // let data_jadi = res.data.data;
          //
          self.response = res.data.data

          if (self.response.length === 0) {
            throw new Error('Data not found')
          }

          if (self.response.length === 0) {
            throw new Error('Data not found')
          }

          this.initSlider(res.data.data.length - 1)
          this.initChart()

          let data_jadi = res.data.data

          if (data_jadi.length > 0) {
            var stations = data_jadi.map((o) => {
              return { lat: o.latitude, lng: o.longitude, _id: o._id }
            })
            var parts = []
            var dataGroupTmp = []
            var max = 2
            data_jadi
              .map((currentItem, index, array) => {
                // Skip the last element to avoid going out of bounds
                if (index < array.length - 1) {
                  const nextItem = array[index + 1]
                  parts.push([
                    {
                      lat: currentItem.latitude,
                      lng: currentItem.longitude,
                    },
                    {
                      lat: nextItem.latitude,
                      lng: nextItem.longitude,
                    },
                  ])
                  const duration =
                    (new Date(nextItem.device_time).getTime() -
                      new Date(currentItem.device_time).getTime()) /
                    1000
                  dataGroupTmp.push({
                    anchors: [currentItem, nextItem],
                    speed:
                      google.maps.geometry.spherical.computeDistanceBetween(
                        new google.maps.LatLng(
                          currentItem.latitude,
                          currentItem.longitude
                        ),
                        new google.maps.LatLng(
                          nextItem.latitude,
                          nextItem.longitude
                        )
                      ) / duration,
                    duration: duration,
                  })
                }
                return null
              })
              .filter((item) => item !== null)

            this.dataGroup = dataGroupTmp

            this.overlay = false
            // Show stations on the map as markers
            let startMarker = new google.maps.Marker({
              position: stations[0],
              map: self.map,
              icon: {
                url: circle_black,
                anchor: new google.maps.Point(10, 10),
                scaledSize: new google.maps.Size(20, 20),
                fillColor: '#00CCBB',
                fillOpacity: 1,
                strokeColor: '',
                strokeWeight: 0,
                labelOrigin: new google.maps.Point(10, 30),
              },
              label: {
                text: 'Start',
                color: 'black',
                fontSize: '12px',
                fontWeight: 'bold',
                backgroundColor: 'black',
                labelClass: 'startendmarker',
              },
            })
            self.markers.push(startMarker)

            let stopMarker = new google.maps.Marker({
              position: stations[stations.length - 1],
              map: self.map,
              icon: {
                url: circle_black,
                anchor: new google.maps.Point(10, 10),
                scaledSize: new google.maps.Size(20, 20),
                fillColor: '#00CCBB',
                fillOpacity: 1,
                strokeColor: '',
                strokeWeight: 0,
                labelOrigin: new google.maps.Point(10, 30),
              },
              label: {
                text: 'Stop',
                color: 'black',
                fontSize: '12px',
                fontWeight: 'bold',
                backgroundColor: 'black',
                labelClass: 'startendmarker',
              },
            })
            self.markers.push(stopMarker)

            for (var i = 0; i < stations.length; i++) {
              let mark = null
              let mark2 = null

              if (data_jadi[i].event_type != 'SAMPLING') {
                let alert_icon = null
                switch (data_jadi[i].event_type) {
                  case 'OVERSPEED':
                    alert_icon = periodic_overspeed
                    break

                  case 'HARSH_BRK':
                    alert_icon = periodic_harsh_brk
                    break

                  case 'HARSH_ACC':
                    alert_icon = periodic_harsh_acc
                    break

                  case 'MB_CN':
                    alert_icon = periodic_mbcn
                    break

                  case 'CRASH':
                    alert_icon = periodic_crash
                    break

                  case 'GEOFENCE_IN':
                    alert_icon = periodic_geo_in
                    break

                  case 'GEOFENCE_OUT':
                    alert_icon = periodic_geo_out
                    break

                  case 'OVERSTAY_ENGINE_ON':
                    alert_icon = periodic_overstay_on
                    break

                  case 'OVERSTAY_ENGINE_OFF':
                    alert_icon = periodic_overstay_off
                    break

                  default:
                    alert_icon = periodic_default
                    break
                }

                mark = new google.maps.Marker({
                  position: stations[i],
                  map: self.map,
                  icon: {
                    url: alert_icon,
                    anchor: new google.maps.Point(15, 50),
                    scaledSize: new google.maps.Size(30, 43),
                    fillColor: '#131B87',
                    fillOpacity: 1,
                    strokeColor: '#131B87',
                    strokeWeight: 5,
                  },
                })
                self.markers.push(mark)

                mark2 = new google.maps.Marker({
                  position: stations[i],
                  map: self.map,
                  icon: {
                    url: circle_red,
                    // path: 'M10 9L5.08772 0L0 9L5.08772 7.41177L10 9Z',
                    anchor: new google.maps.Point(5, 5),
                    scaledSize: new google.maps.Size(10, 10),
                    fillColor: '#131B87',
                    fillOpacity: 1,
                    strokeColor: '',
                    strokeWeight: 0,
                    // rotation: parseInt(data_jadi[i].direction),
                  },
                })
                self.markers.push(mark2)
              } else {
                mark = new google.maps.Marker({
                  position: stations[i],
                  map: self.map,
                  icon: {
                    url: circle,
                    // path: 'M10 9L5.08772 0L0 9L5.08772 7.41177L10 9Z',
                    anchor: new google.maps.Point(5, 5),
                    scaledSize: new google.maps.Size(10, 10),
                    fillColor: '#131B87',
                    fillOpacity: 1,
                    strokeColor: '',
                    strokeWeight: 0,
                    rotation: parseInt(data_jadi[i].direction),
                  },
                })
                self.markers.push(mark)
              }

              let mark_tmp = stations[i]
              google.maps.event.addListener(mark, 'click', () => {
                //
                self.infoBoxOpen = false
                // //
                this.sliderValue = this.response.findIndex((x) => {
                  return x._id == mark_tmp._id
                })

                self.$vs.loading()
                REPO.getOneDetail(mark_tmp._id)
                  .then((rress) => {
                    self.$vs.loading.close()
                    // self.selectedLocation = rress.data.data
                    self.selectedLocation.latitude = mark_tmp.lat
                    self.selectedLocation.longitude = mark_tmp.lng
                    self.infoBoxOpen = true
                  })
                  .catch((err) => {
                    self.$vs.loading()
                  })
              })
              if (mark2) {
                google.maps.event.addListener(mark2, 'click', () => {
                  //
                  self.infoBoxOpen = false
                  // //
                  this.sliderValue = this.response.findIndex((x) => {
                    return x._id == mark_tmp._id
                  })

                  self.$vs.loading()
                  REPO.getOneDetail(mark_tmp._id)
                    .then((rress) => {
                      self.$vs.loading.close()
                      // self.selectedLocation = rress.data.data
                      self.selectedLocation.latitude = mark_tmp.lat
                      self.selectedLocation.longitude = mark_tmp.lng
                      self.infoBoxOpen = true
                    })
                    .catch((err) => {
                      self.$vs.loading()
                    })
                })
              }
            }

            const routeService = new RouteService(
              self.map,
              self.polyline,
              self.dataGroup,
              parts,
              self.vehicle_category
            )
            routeService.setCallbacks({
              onComplete: (result) => {
                self.startAnimation()
                self.loadingBtnStop('playback-map')
              },
              onError: (error) => {
                self.loadingBtnStop('playback-map')
                // console.error(error)
              },
            })

            routeService.processRoutes()

            this.loadingBtnStop('btn-load-1')
            this.calculated = true
          } else {
            this.loadingBtnStop('btn-load-1')
            this.loadingBtnStop('playback-map')
          }
        })
        .catch((err) => {
          this.loadingBtnStop('btn-load-1')
          this.loadingBtnStop('playback-map')
          // alert error
          this.$vs.notify({
            title: 'No Data Found.',
            text: 'Please select another time and date to see periodic tracking',
            title: 'No Data Found.',
            text: 'Please select another time and date to see periodic tracking',
            color: 'danger',
            position: 'bottom-right',
          })
        })
    },
    handleDataPointSelection(event, chartContext, config) {
      const { seriesIndex, dataPointIndex } = config;
      console.log('Data Point Index:', dataPointIndex);
      if (dataPointIndex >= 0) { // Allow index 0 as well
        this.setSliderValue(50);
      }
    },
    handleUPlotSelect(index) {
      if (!this.response.length) return

      const maxIndex = this.response.length - 1
      this.sliderValue = Math.max(0, Math.min(index, maxIndex))
    },
    handleUPlotError(error) {
      console.error('uPlot playback chart failed, fallback to ApexCharts:', error)
      this.useUPlotChart = false
    },
    setSliderValue(val) {
      // this.$set(this, 'sliderValue', val); // Ensure reactivity
      console.log('Updated sliderValue:', this.sliderValue);
    },
  },

  mounted() {
    let self = this
    //
    this.id = this.license_plate
    this.$refs.mapRef.$mapPromise.then((map) => {
      google.maps.event.addListener(map, 'zoom_changed', function () {
        // Determines map type and prevent illegal zoom levels
        //
        var zoom = map.getZoom()
        self.zoomNow = zoom
        //
      })
      //

      this.map = map
      self.directionsService = new google.maps.DirectionsService()
      var rendererOptions = {
        polylineOptions: {
          strokeColor: '#78a4ff',
        },
        map: map,
      }
      self.directionsDisplay = new google.maps.DirectionsRenderer(
        rendererOptions
      )

      self.icon = {
        path: car,
        scale: 0.7,
        strokeColor: 'white',
        strokeWeight: 0.1,
        fillOpacity: 1,
        fillColor: '#404040',
        offset: '5%',
        // rotation: parseInt(heading[i]),
        anchor: new google.maps.Point(10, 25), // orig 10,50 back of car, 10,0 front of car, 10,25 center of car
      }
      google.maps.LatLng.prototype.distanceFrom = function (newLatLng) {
        var EarthRadiusMeters = 6378137.0 // meters
        var lat1 = this.lat()
        var lon1 = this.lng()
        var lat2 = newLatLng.lat()
        var lon2 = newLatLng.lng()
        var dLat = ((lat2 - lat1) * Math.PI) / 180
        var dLon = ((lon2 - lon1) * Math.PI) / 180
        var a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos((lat1 * Math.PI) / 180) *
          Math.cos((lat2 * Math.PI) / 180) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2)
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        var d = EarthRadiusMeters * c
        return d
      }

      google.maps.LatLng.prototype.latRadians = function () {
        return (this.lat() * Math.PI) / 180
      }

      google.maps.LatLng.prototype.lngRadians = function () {
        return (this.lng() * Math.PI) / 180
      }

      // === A method which returns the length of a path in metres ===
      google.maps.Polygon.prototype.Distance = function () {
        var dist = 0
        for (var i = 1; i < this.getPath().getLength(); i++) {
          dist += this.getPath()
            .getAt(i)
            .distanceFrom(this.getPath().getAt(i - 1))
        }
        return dist
      }

      // === A method which returns a GLatLng of a point a given distance along the path ===
      // === Returns null if the path is shorter than the specified distance ===
      google.maps.Polygon.prototype.GetPointAtDistance = function (metres) {
        // some awkward special cases
        if (metres == 0) return this.getPath().getAt(0)
        if (metres < 0) return null
        if (this.getPath().getLength() < 2) return null
        var dist = 0
        var olddist = 0
        for (var i = 1; i < this.getPath().getLength() && dist < metres; i++) {
          olddist = dist
          dist += this.getPath()
            .getAt(i)
            .distanceFrom(this.getPath().getAt(i - 1))
        }
        if (dist < metres) {
          return null
        }
        var p1 = this.getPath().getAt(i - 2)
        var p2 = this.getPath().getAt(i - 1)
        var m = (metres - olddist) / (dist - olddist)
        return new google.maps.LatLng(
          p1.lat() + (p2.lat() - p1.lat()) * m,
          p1.lng() + (p2.lng() - p1.lng()) * m
        )
      }

      // === A method which returns an array of GLatLngs of points a given interval along the path ===
      google.maps.Polygon.prototype.GetPointsAtDistance = function (metres) {
        var next = metres
        var points = []
        // some awkward special cases
        if (metres <= 0) return points
        var dist = 0
        var olddist = 0
        for (var i = 1; i < this.getPath().getLength(); i++) {
          olddist = dist
          dist += this.getPath()
            .getAt(i)
            .distanceFrom(this.getPath().getAt(i - 1))
          while (dist > next) {
            var p1 = this.getPath().getAt(i - 1)
            var p2 = this.getPath().getAt(i)
            var m = (next - olddist) / (dist - olddist)
            points.push(
              new google.maps.LatLng(
                p1.lat() + (p2.lat() - p1.lat()) * m,
                p1.lng() + (p2.lng() - p1.lng()) * m
              )
            )
            next += metres
          }
        }
        return points
      }

      // === A method which returns the Vertex number at a given distance along the path ===
      // === Returns null if the path is shorter than the specified distance ===
      google.maps.Polygon.prototype.GetIndexAtDistance = function (metres) {
        // some awkward special cases
        if (metres == 0) return this.getPath().getAt(0)
        if (metres < 0) return null
        var dist = 0
        var olddist = 0
        for (var i = 1; i < this.getPath().getLength() && dist < metres; i++) {
          olddist = dist
          dist += this.getPath()
            .getAt(i)
            .distanceFrom(this.getPath().getAt(i - 1))
        }
        if (dist < metres) {
          return null
        }
        return i
      }
      // === Copy all the above functions to GPolyline ===
      google.maps.Polyline.prototype.Distance =
        google.maps.Polygon.prototype.Distance
      google.maps.Polyline.prototype.GetPointAtDistance =
        google.maps.Polygon.prototype.GetPointAtDistance
      google.maps.Polyline.prototype.GetPointsAtDistance =
        google.maps.Polygon.prototype.GetPointsAtDistance
      google.maps.Polyline.prototype.GetIndexAtDistance =
        google.maps.Polygon.prototype.GetIndexAtDistance
      self.polyline = new google.maps.Polyline({
        path: [],
        strokeColor: '#78a4ff',
        strokeWeight: 3,
      })
      self.poly2 = new google.maps.Polyline({
        path: [],
        strokeColor: '#78a4ff',
        strokeWeight: 3,
      })
    })

    this.chartStatic = {
      height: 350,
      type: 'area',
      selection: {
        enabled: true, // Enable data point selection
      },
      events: {
        click: function (event, chartContext, opts) {
          console.log(event, chartContext, opts, this.sliderValue);
          this.sliderValue = opts.dataPointIndex
        }.bind(this)
      },
    }
  },
}
</script>

<style lang="scss">
$rail-fill-color: #ff1111;

@import '~vue-range-slider/dist/vue-range-slider.scss';

.datetimepicker>.flex {
  display: none !important;
}

.visible>.flex {
  display: block !important;
  left: 0;
}

.date-popup>.vs-popup>.vs-popup--content {
  overflow: visible;
}

.con-slot-tabs {
  height: calc(100% - 38px);

  .con-tab {
    height: 100%;
  }
}
</style>

<style lang="scss" scoped>
.control-place {
  position: absolute;
  z-index: 2;
  bottom: 3px;
  // bottom: -10px;
  // left: 50%;
  // transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  width: calc(100% - 60px);

  .controls {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }
}

.control-side {
  position: absolute;
  z-index: 3;
  bottom: 150px;
  right: 10px;
  transform: translateY(50%);
  display: flex;
  flex-direction: column;

  .controls {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }
}

.startendmarker {
  background-color: black;
  border-radius: 5px;
  padding: 5px;
  color: black;
  // font-weight: bold;
  // font-size: 12px;
}

.tooltip-top {
  position: absolute;
  top: -30px;
  left: -10px;
  background: #ff1111;
  color: white;
  padding: 5px;
  border-radius: 5px;
  font-size: 12px;
}

.control-btn {
  background: linear-gradient(30deg, #d23030 0%, #f89595 100%);
  border-radius: 50%;
  margin: 10px;
  font-size: 12px;
  color: white;
  width: 30px;
  font-weight: bold;
  cursor: pointer;
  height: 30px;
  padding-left: 8px;
  padding-top: 7px;
  box-shadow: 2px 3px 4px dimgrey;
}

.buletan {
  float: left;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  margin-top: 3px;
  margin-right: 6px;
}

.biru {
  background: blue;
}

.merah {
  background: red;
}

.item {
  background: black;
}

.ijo {
  background: green;
}

input {
  border: 2px solid #1489da;
}

.datetimepicker>.flex {
  display: none !important;
}

.visible>.flex {
  display: flex !important;
}

.date-popup>.vs-popup>.vs-popup--content {
  overflow: visible;
}

.heights {
  width: 100%;
  height: calc(100vh - 16.5rem);
}

.legenda {
  box-shadow: -2px 2px 4px #97b5ca;
  padding: 5px;
  right: 0;
  font-size: 12px;
  width: 150px;
  position: absolute;
  z-index: 1;
  background: white;
  border-radius: 7px;
}

.grab:hover {
  cursor: n-resize;
}

// div.gmnoprint {
//   z-index: 6 !important;
// }</style>
